
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gallery/[...alias]",
      function () {
        return require("private-next-pages/gallery/[...alias].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gallery/[...alias]"])
      });
    }
  